import { render, staticRenderFns } from "./CartItemsList.vue?vue&type=template&id=4dd5e50d&scoped=true&"
import script from "./CartItemsList.vue?vue&type=script&lang=js&"
export * from "./CartItemsList.vue?vue&type=script&lang=js&"
import style0 from "./CartItemsList.vue?vue&type=style&index=0&id=4dd5e50d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5e50d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VSpacer,VSwitch,VTextField})
